// This file is automatically generated. Do not edit manually.

import { ServerSideDataModelRequest } from "src/api/generated/common/dataGrids/serverSideDataModelRequest";
import { ServerSideDataModelResult } from "src/api/generated/common/dataGrids/serverSideDataModelResult";
import { SalesLeadView } from "src/api/generated/erp/db/types/tables/salesLeadView";
import { SalesLead } from "src/api/generated/erp/db/types/tables/salesLead";
import { ObjectAttributeValueWithFieldId } from "src/api/generated/erp/common/objectAttributes/model/objectAttributeValueWithFieldId";
import { ContactCreateInput } from "src/api/generated/erp/contacts/model/contactCreateInput";
import { SalesLeadsUpdateService_UpdateRequest } from "src/api/generated/erp/sales/crm/salesLeads/service/salesLeadsUpdateService";
import { SalesLeadContactService_ExpectedPrimaryContact } from "src/api/generated/erp/sales/crm/salesLeads/service/salesLeadContactService";
import { ObjectAttributeField } from "src/api/generated/erp/common/objectAttributes/model/objectAttributeField";
import { ObjectAttribute } from "src/api/generated/erp/db/types/tables/objectAttribute";
import { Customer } from "src/api/generated/erp/db/types/tables/customer";
import { CustomerGroup } from "src/api/generated/erp/db/types/tables/customerGroup";
import { CustomerAddress } from "src/api/generated/erp/db/types/tables/customerAddress";
import { Contact } from "src/api/generated/erp/db/types/tables/contact";
import { SalesArea } from "src/api/generated/erp/db/types/tables/salesArea";
import { SalesLeadSource } from "src/api/generated/erp/db/types/tables/salesLeadSource";
import { SalesPipeline } from "src/api/generated/erp/db/types/tables/salesPipeline";
import { SalesPipelinePhase } from "src/api/generated/erp/db/types/tables/salesPipelinePhase";
import { SalespersonView } from "src/api/generated/erp/db/types/tables/salespersonView";
import { CustomerOrderOfferState } from "src/api/generated/erp/db/types/enums/customerOrderOfferState";
import { Country } from "src/api/generated/io/aavo/applications/db/erp/types/country";
import { IsoDateTimeString } from "src/types/dateTime";
import { CustomerType } from "src/api/generated/erp/db/types/enums/customerType";
import { SalesLeadState } from "src/api/generated/erp/db/types/enums/salesLeadState";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace SalesLeadsApi {
	export async function getFormInitData(args: {
		salesLeadId: number | null | undefined;
		customerId?: number | null | undefined;
	}): Promise<SalesLeadsApi_FormInitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/crm/SalesLeads/getFormInitData",
			method: "POST",
			data: {
				salesLeadId: args.salesLeadId,
				customerId: args.customerId,
			},
		});
		return response as SalesLeadsApi_FormInitData;
	}

	export async function getAllForBoard(args: {
		searchQuery?: string;
		salespersonIds?: Array<number>;
		customerGroupIds?: Array<number>;
		salesAreaIds?: Array<number>;
		salesPipelineId?: number | null | undefined;
	}): Promise<SalesLeadsApi_BoardData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/crm/SalesLeads/getAllForBoard",
			method: "POST",
			data: {
				searchQuery: args.searchQuery,
				salespersonIds: args.salespersonIds,
				customerGroupIds: args.customerGroupIds,
				salesAreaIds: args.salesAreaIds,
				salesPipelineId: args.salesPipelineId,
			},
		});
		return response as SalesLeadsApi_BoardData;
	}

	export async function getAll(args: {
		searchQuery?: string;
		showOpen?: boolean;
		showDiscarded?: boolean;
		showLost?: boolean;
		showWon?: boolean;
		customerId?: number | null | undefined;
		dataModelRequest: ServerSideDataModelRequest;
	}): Promise<ServerSideDataModelResult<SalesLeadView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/crm/SalesLeads/getAll",
			method: "POST",
			data: {
				searchQuery: args.searchQuery,
				showOpen: args.showOpen,
				showDiscarded: args.showDiscarded,
				showLost: args.showLost,
				showWon: args.showWon,
				customerId: args.customerId,
				dataModelRequest: args.dataModelRequest,
			},
		});
		return response as ServerSideDataModelResult<SalesLeadView>;
	}

	export async function getUnallocated(args: { searchQuery?: string }): Promise<Array<SalesLeadView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/crm/SalesLeads/getUnallocated",
			method: "POST",
			data: {
				searchQuery: args.searchQuery,
			},
		});
		return response as Array<SalesLeadView>;
	}

	export async function insert(args: {
		salesLead: SalesLead;
		attributes?: Array<ObjectAttributeValueWithFieldId>;
		contacts?: Array<ContactCreateInput>;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/crm/SalesLeads/insert",
			method: "POST",
			data: {
				salesLead: args.salesLead,
				attributes: args.attributes,
				contacts: args.contacts,
			},
		});
		return response as number;
	}

	export async function update(args: {
		salesLead: SalesLeadsUpdateService_UpdateRequest;
		attributes?: Array<ObjectAttributeValueWithFieldId> | null | undefined;
		expectedPrimaryContact?: SalesLeadContactService_ExpectedPrimaryContact | null | undefined;
	}): Promise<SalesLead> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/crm/SalesLeads/update",
			method: "POST",
			data: {
				salesLead: args.salesLead,
				attributes: args.attributes,
				expectedPrimaryContact: args.expectedPrimaryContact,
			},
		});
		return response as SalesLead;
	}

	export async function delete_(args: { salesLeadIds: Array<number> }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/crm/SalesLeads/delete",
			method: "POST",
			data: {
				salesLeadIds: args.salesLeadIds,
			},
		});
		return response as void;
	}

	export async function markAsLost(args: { salesLeadIds: Array<number>; lostReason?: string }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/crm/SalesLeads/markAsLost",
			method: "POST",
			data: {
				salesLeadIds: args.salesLeadIds,
				lostReason: args.lostReason,
			},
		});
		return response as void;
	}

	export async function discard(args: { salesLeadIds: Array<number>; discardedReason?: string }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/crm/SalesLeads/discard",
			method: "POST",
			data: {
				salesLeadIds: args.salesLeadIds,
				discardedReason: args.discardedReason,
			},
		});
		return response as void;
	}

	export async function reopen(args: { salesLeadIds: Array<number> }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/crm/SalesLeads/reopen",
			method: "POST",
			data: {
				salesLeadIds: args.salesLeadIds,
			},
		});
		return response as void;
	}

	export async function allocate(args: {
		salesLeadIds: Array<number>;
		salespersonId: number;
		moveOpenActivities?: boolean;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/crm/SalesLeads/allocate",
			method: "POST",
			data: {
				salesLeadIds: args.salesLeadIds,
				salespersonId: args.salespersonId,
				moveOpenActivities: args.moveOpenActivities,
			},
		});
		return response as void;
	}
}

export interface SalesLeadsApi_FormInitData {
	attributeFields: Array<ObjectAttributeField>;
	attributeValues: Array<ObjectAttribute>;
	customer: Customer | null | undefined;
	customerGroupOptions: Array<CustomerGroup>;
	defaultDocumentAddress: CustomerAddress | null | undefined;
	primaryContact: Contact | null | undefined;
	salesAreaOptions: Array<SalesArea>;
	salesLead: SalesLead | null | undefined;
	salesLeadSourceOptions: Array<SalesLeadSource>;
	salesPipelineOptions: Array<SalesPipeline>;
	salesPipelinePhaseOptions: Array<SalesPipelinePhase>;
	salespersonOptions: Array<SalespersonView>;
}

export interface SalesLeadsApi_BoardData {
	customerGroupOptions: Array<CustomerGroup>;
	salesAreaOptions: Array<SalesArea>;
	salesLeads: Array<SalesLeadsApi_BoardSalesLead>;
	salesPipelineId: number | null | undefined;
	salesPipelinePhases: Array<SalesPipelinePhase>;
	salesPipelines: Array<SalesPipeline>;
	salespersonOptions: Array<SalespersonView>;
}

export interface SalesLeadsApi_BoardSalesLead {
	customerOrderOfferState: CustomerOrderOfferState | null | undefined;
	customerOrderOfferTotalPrice: number | null | undefined;
	address_1: string;
	address_2: string;
	city: string;
	contactEmail: string;
	contactName: string;
	contactPhone: string;
	country: Country;
	createdAt: IsoDateTimeString;
	createdByUserId: number | null | undefined;
	createdByUserName: string | null | undefined;
	customerGroupId: number | null | undefined;
	customerGroupName: string | null | undefined;
	customerId: number | null | undefined;
	customerName: string;
	customerOrderOfferId: number | null | undefined;
	customerType: CustomerType;
	description: string;
	discardedAt: IsoDateTimeString | null | undefined;
	discardedByUserId: number | null | undefined;
	discardedByUserName: string | null | undefined;
	discardedReason: string | null | undefined;
	estimatedValue: number | null | undefined;
	followUpStatus: string | null | undefined;
	fullAddress: string | null | undefined;
	lastUpdated: IsoDateTimeString;
	lostAt: IsoDateTimeString | null | undefined;
	lostReason: string | null | undefined;
	postalCode: string;
	salesAreaId: number | null | undefined;
	salesAreaName: string | null | undefined;
	salesLeadId: number;
	salesLeadSourceId: number | null | undefined;
	salesLeadSourceName: string | null | undefined;
	salesLeadState: SalesLeadState;
	salesPipelineId: number;
	salesPipelineName: string | null | undefined;
	salesPipelinePhaseColor: string | null | undefined;
	salesPipelinePhaseEnteredAt: IsoDateTimeString | null | undefined;
	salesPipelinePhaseId: number | null | undefined;
	salesPipelinePhaseName: string | null | undefined;
	salespersonEmail: string | null | undefined;
	salespersonId: number | null | undefined;
	salespersonName: string | null | undefined;
	salespersonPhone: string | null | undefined;
	wonAt: IsoDateTimeString | null | undefined;
}
